export default "__VITE_ASSET__cb9cff3c__"